// Team Insights — Subscription / plan request strings (prefix `ins.plan.`)
const en = {
  "ins.plan.current": "Current plan",
  "ins.plan.yourPlan": "Your plan",
  "ins.plan.best": "Best value",
  "ins.plan.billing": "Billing cycle",
  "ins.plan.monthly": "Monthly",
  "ins.plan.yearly": "Yearly",
  "ins.plan.save": "save {pct}%",
  "ins.plan.priceMonthly": "Monthly price",
  "ins.plan.priceYearly": "Yearly price",
  "ins.plan.requestUpgrade": "Request upgrade",
  "ins.plan.requestChange": "Request change",
  "ins.plan.requested": "Request pending",
  "ins.plan.pendingBadge": "Request pending: {plan}",
  "ins.plan.alreadyRequested": "You already have a pending request for this plan.",
  "ins.plan.loadError": "We couldn't load the plans. Please try again.",
  "ins.plan.noPaymentNote": "Online payment isn't available yet. Plan changes are activated by our team after your request — you'll get a notification.",
  "ins.plan.dialogTitle": "Request the {plan} plan",
  "ins.plan.dialogDesc": "Our team will review your request and contact you about payment and activation.",
  "ins.plan.noteLabel": "Note for our team (optional)",
  "ins.plan.notePlaceholder": "e.g. preferred payment method, number of artists…",
  "ins.plan.cancel": "Cancel",
  "ins.plan.send": "Send request",
  "ins.plan.sentTitle": "Request sent",
  "ins.plan.sentDesc": "We've opened a support ticket for you and notified our team. You'll be notified as soon as your plan is updated.",
  "ins.plan.done": "Done",
};
const tr = {
  "ins.plan.current": "Mevcut plan",
  "ins.plan.yourPlan": "Planınız",
  "ins.plan.best": "En avantajlı",
  "ins.plan.billing": "Faturalama dönemi",
  "ins.plan.monthly": "Aylık",
  "ins.plan.yearly": "Yıllık",
  "ins.plan.save": "%{pct} tasarruf",
  "ins.plan.priceMonthly": "Aylık fiyat",
  "ins.plan.priceYearly": "Yıllık fiyat",
  "ins.plan.requestUpgrade": "Yükseltme talep et",
  "ins.plan.requestChange": "Değişiklik talep et",
  "ins.plan.requested": "Talep beklemede",
  "ins.plan.pendingBadge": "Bekleyen talep: {plan}",
  "ins.plan.alreadyRequested": "Bu plan için zaten bekleyen bir talebiniz var.",
  "ins.plan.loadError": "Planlar yüklenemedi. Lütfen tekrar deneyin.",
  "ins.plan.noPaymentNote": "Online ödeme henüz mevcut değil. Plan değişiklikleri talebinizden sonra ekibimiz tarafından etkinleştirilir — bildirim alırsınız.",
  "ins.plan.dialogTitle": "{plan} planını talep et",
  "ins.plan.dialogDesc": "Ekibimiz talebinizi inceleyip ödeme ve etkinleştirme için sizinle iletişime geçecek.",
  "ins.plan.noteLabel": "Ekibimize not (isteğe bağlı)",
  "ins.plan.notePlaceholder": "örn. tercih ettiğiniz ödeme yöntemi, sanatçı sayısı…",
  "ins.plan.cancel": "Vazgeç",
  "ins.plan.send": "Talebi gönder",
  "ins.plan.sentTitle": "Talep gönderildi",
  "ins.plan.sentDesc": "Sizin için bir destek talebi açtık ve ekibimizi bilgilendirdik. Planınız güncellendiğinde bildirim alacaksınız.",
  "ins.plan.done": "Tamam",
};
const es = {
  "ins.plan.current": "Plan actual",
  "ins.plan.yourPlan": "Tu plan",
  "ins.plan.best": "Mejor valor",
  "ins.plan.billing": "Ciclo de facturación",
  "ins.plan.monthly": "Mensual",
  "ins.plan.yearly": "Anual",
  "ins.plan.save": "ahorra {pct}%",
  "ins.plan.priceMonthly": "Precio mensual",
  "ins.plan.priceYearly": "Precio anual",
  "ins.plan.requestUpgrade": "Solicitar mejora",
  "ins.plan.requestChange": "Solicitar cambio",
  "ins.plan.requested": "Solicitud pendiente",
  "ins.plan.pendingBadge": "Solicitud pendiente: {plan}",
  "ins.plan.alreadyRequested": "Ya tienes una solicitud pendiente para este plan.",
  "ins.plan.loadError": "No pudimos cargar los planes. Inténtalo de nuevo.",
  "ins.plan.noPaymentNote": "El pago en línea aún no está disponible. Nuestro equipo activa los cambios de plan tras tu solicitud y recibirás una notificación.",
  "ins.plan.dialogTitle": "Solicitar el plan {plan}",
  "ins.plan.dialogDesc": "Nuestro equipo revisará tu solicitud y te contactará para el pago y la activación.",
  "ins.plan.noteLabel": "Nota para nuestro equipo (opcional)",
  "ins.plan.notePlaceholder": "p. ej. método de pago preferido, número de artistas…",
  "ins.plan.cancel": "Cancelar",
  "ins.plan.send": "Enviar solicitud",
  "ins.plan.sentTitle": "Solicitud enviada",
  "ins.plan.sentDesc": "Hemos abierto un ticket de soporte y avisado a nuestro equipo. Te notificaremos en cuanto se actualice tu plan.",
  "ins.plan.done": "Listo",
};
export default { en, tr, es };
